import { useLocation } from 'react-router-dom';
import { useEffect } from "react";
import { createWidget } from '@sber-ecom-core/sberpay-widget';
import React from 'react';

const Sberpay = ({orderId}) => {
  const widget = createWidget("PRODUCTION");
  const location = useLocation();
  const backUrl = window.location.origin + "/purchases";
  const params = new URLSearchParams(location.search);
  const allParams = Object.fromEntries(params.entries());

  const handleClick = () => {
    const params = {
        bankInvoiceId: orderId,
        backUrl,
    };
    widget.open(params);
  };  

  useEffect(handleClick, [])

  return<div />
}

export default Sberpay;